import { Box, Chip, Typography } from "@mui/material";

import type { ContractMeta } from "CommissionDistribution/Models/types";

type Props = {
	meta: ContractMeta;
};

export const CommissionDistributionContractMeta = ({ meta }: Props) => {
	const segments = [meta.category, meta.product, meta.partner, meta.client]
		.map((s) => s?.trim())
		.filter((s): s is string => !!s);

	if (segments.length === 0 && !meta.division) {
		return null;
	}

	return (
		<Box
			sx={{
				display: "flex",
				alignItems: "center",
				flexWrap: "wrap",
				gap: 0.5,
				mb: 1,
			}}
		>
			{!!meta.division && (
				<Chip
					label={meta.division}
					size="small"
					color="primary"
					variant="outlined"
					sx={{ fontWeight: 700, height: 20 }}
				/>
			)}
			{segments.map((segment, idx) => (
				<Box
					key={segment}
					sx={{ display: "flex", alignItems: "center", gap: 0.5 }}
				>
					{(idx > 0 || !!meta.division) && (
						<Typography variant="caption" color="text.disabled">
							·
						</Typography>
					)}
					<Typography variant="caption" color="text.secondary">
						{segment}
					</Typography>
				</Box>
			))}
		</Box>
	);
};
